module.exports = __webpack_public_path__ + "img/icon_board_color.ed3fe52b.svg";